import { useEffect, useState } from "react";
import { TireDetailCard } from "../../../components/TireDetailCard";
import { getInventoryByWheelFitment } from "../../../services/Tires";

type WheelsProps = {
    primaryKey: null | number;
    selectedTireSizeId: null | number;
    selectedIsRearTireSize: boolean;
    selectedRearTireSizeId: null | number;
    setPleaseWaitPopup: (value: boolean) => void;
    selectedTireCount: number;
    selectedWheelProducts: any[];
    selectedTireWidth: string;
    selectedTireRatio: string;
    selectedTireDiameter: string;
    selectedRearTireWidth: string;
    selectedRearTireRatio: string;
    selectedRearTireDiameter: string;
    status: string;
    isCommercial: boolean;
    locationId: number;
    goToNextPage: () => void;
    getDataFromWheels: (
        selectedWheels: any[]
    ) => void;
}

export const Wheels = ({
    primaryKey,
    selectedTireSizeId,
    selectedIsRearTireSize,
    selectedRearTireSizeId,
    setPleaseWaitPopup,
    selectedTireCount,
    selectedWheelProducts,
    selectedTireWidth,
    selectedTireRatio,
    selectedTireDiameter,
    selectedRearTireWidth,
    selectedRearTireRatio,
    selectedRearTireDiameter,
    status,
    locationId,
    isCommercial,
    goToNextPage,
    getDataFromWheels
}: WheelsProps) => {
    const [selectedWheelPosition, setSelectedWheelPosition] = useState<number>(1);
    const [inventroyData, setInventoryData] = useState<any[]>([]);
    const [currentTireFitmentId, setCurrentTireFitmentId] = useState<null | number>(null);
    const [selectedWheels, setSelectedWheels] = useState<any[]>([]);

    useEffect(() => {
        if (selectedWheelPosition === 1) {
            setCurrentTireFitmentId(selectedTireSizeId)
        }
        else {
            setCurrentTireFitmentId(selectedRearTireSizeId)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedWheelPosition])

    useEffect(() => {
        if (currentTireFitmentId && currentTireFitmentId > 0) {
            setPleaseWaitPopup(true);
            getInventoryByWheelFitment(currentTireFitmentId, isCommercial, locationId)
                .then((data) => {
                    setInventoryData(data);
                    setPleaseWaitPopup(false);
                })
                .catch((error) => {
                    console.error(error);
                    setPleaseWaitPopup(false);
                    setInventoryData([]);
                })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentTireFitmentId])


    useEffect(() => {
        setSelectedWheels(selectedWheelProducts)
    }, [selectedWheelProducts])

    const handleNext = () => {
        if (!primaryKey || status === "Scheduled" || status === "Queued" || status === "InProgress") {
            getDataFromWheels(selectedWheels);
            goToNextPage();

        }
        else {
            goToNextPage();
        }
    }

    return (
        <div className="w-full mt-2">
            <div className={`w-full pb-4`}>
                <div className="w-full flex items-center justify-between gap-6 p-2 bg-white border-b">
                    <div className="flex items-center gap-3.5">
                        {
                            (selectedIsRearTireSize && selectedRearTireSizeId) && (
                                <>
                                    <span className="text-sm font-semibold text-black">Filters:</span>
                                    {
                                        (selectedIsRearTireSize && selectedRearTireSizeId) && (
                                            <div className="flex items-center">
                                                <select
                                                    value={selectedWheelPosition}
                                                    onChange={(e) => setSelectedWheelPosition(Number(e.target.value))}
                                                    className="border border-gray-300 rounded-lg px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary"
                                                >
                                                    <option value="1">Front</option>
                                                    <option value="2">Rear</option>
                                                </select>
                                            </div>
                                        )
                                    }

                                </>
                            )
                        }

                    </div>
                    <div className="flex items-center gap-2.5">
                        {
                            selectedTireSizeId && (
                                <div className="border-r px-1 py-2">
                                    <span className="text-sm font-medium text-gray-900"><span className="font-semibold">{selectedIsRearTireSize ? "Front Tire Size" : "Tire Size"}:</span> {selectedTireWidth}/{selectedTireRatio} R{selectedTireDiameter}{isCommercial ? "C" : ""}</span>
                                </div>
                            )
                        }

                        {
                            (selectedIsRearTireSize && selectedRearTireSizeId) && (
                                <div className="border-r px-1 py-2">
                                    <span className="text-sm font-medium text-gray-900"><span className="font-semibold">Rear Tire Size:</span> {selectedRearTireWidth}/{selectedRearTireRatio} R{selectedRearTireDiameter}{isCommercial ? "C" : ""}</span>
                                </div>
                            )
                        }

                        <button onClick={() => { handleNext() }} className="bg-primary hover:bg-orange-600 text-white text-sm py-3 px-8 rounded-[70px] font-medium transition">
                            Next
                        </button>


                    </div>
                </div>
            </div>
            <div className="mt-2 p-2 w-[60%]">
                <div className="w-full border-b pb-4">
                    <span className="text-sm font-semibold text-gray-800">
                        Wheels
                    </span>
                    <div className="w-full mt-2 p-4 flex flex-col items-center space-y-8">
                        {
                            inventroyData?.map((item: any, index: number) => (
                                <TireDetailCard key={index} primaryKey={primaryKey} status={status} data={item} selectedTires={selectedWheels} setSelectedTires={setSelectedWheels} selectedTireCount={selectedTireCount} />
                            ))
                        }
                    </div>
                    {
                        inventroyData.length === 0 && (
                            <div className="flex items-center justify-center">
                                <span>No Wheel found for this tire size.</span>
                            </div>
                        )
                    }

                </div>
            </div>
        </div>
    )
}